import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import { GetAllBrands, GetProductTypes, AddProduct, GetProduct, EditProduct, UploadProductPic } from '../../fetchs';

import './product.styles.css';

const useStyles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 1200,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    width: 600,
    display: 'flex',
    flexWrap: 'wrap',
  },
  buttonProgress: {
    color: green[500],
    position: 'relative',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
});

class Product extends Component {
  constructor(props) {
    super(props);

    this.state = {
      brandId: 0,
      productTypeId: 0,
      name: '',
      amount: 0,
      amountType: '',
      description: '',
      fullDescription: '',
      picUrl: '',
      price: 0,
      availableCount: 0,
      priceWithOffer: 0,
      brands: [],
      productTypes: [],
      loading: false,
      saving: false,
      uploadPic: false
    }
  }

  componentDidMount() {
    GetAllBrands()
      .then(response => {
        return response.json();
      })
      .then(responseJson => {
        this.setState({ brands: responseJson });
      })
      .catch(error => {
        console.error(error);
      });

    GetProductTypes(0, 1000)
      .then(response => {
        return response.json();
      })
      .then(responseJson => {
        this.setState({ productTypes: responseJson.data });
      })
      .catch(error => {
        console.error(error);
      });

    const productId = this.props.match.params.productId;
    if (productId) {
      this.loadProduct(productId);
    }
  }

  loadProduct = (productId) => {
    this.setState({ loading: true });
    GetProduct(productId)
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      })
      .then(responseJson => {
        this.setState({
          productId: productId,
          brandId: responseJson.brandId,
          productTypeId: responseJson.productTypeId,
          name: responseJson.name,
          amount: responseJson.amount,
          amountType: responseJson.amountType,
          description: responseJson.description,
          fullDescription: responseJson.fullDescription,
          picUrl: responseJson.picUrl,
          price: responseJson.price,
          availableCount: responseJson.availableCount,
          priceWithOffer: responseJson.priceWithOffer
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        console.log(error);
      });
  }

  handleSave = () => {
    if (this.props.match.params.productId) {
      EditProduct(this.state.productId, {
        brandId: this.state.brandId,
        productTypeId: this.state.productTypeId,
        name: this.state.name,
        amount: this.state.amount,
        amountType: this.state.amountType,
        description: this.state.description,
        fullDescription: this.state.fullDescription,
        picUrl: this.state.picUrl,
        price: this.state.price,
        priceWithOffer: this.state.priceWithOffer,
        availableCount: this.state.availableCount
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/products');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    } else {
      AddProduct({
        brandId: this.state.brandId,
        productTypeId: this.state.productTypeId,
        name: this.state.name,
        amount: this.state.amount,
        amountType: this.state.amountType,
        description: this.state.description,
        fullDescription: this.state.fullDescription,
        picUrl: this.state.picUrl,
        price: this.state.price,
        priceWithOffer: this.state.priceWithOffer,
        availableCount: this.state.availableCount
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/products');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    }
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  handleCheckChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  handleSelectFile = event => {
    this.setState({ uploadPic: true });
    UploadProductPic(this.state.productId, event.target.files[0])
      .then(response => {
        this.setState({ uploadPic: false });
        return response.json();
      }).then(responseJson => {
        this.setState({
          picUrl: responseJson.path
        })
      }).catch(error => {
        console.error(error);
      })
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              افزودن محصول جدید
            </Typography>
            <Grid container>
              <Grid item md={7}>
                <React.Fragment>
                  <form className={classes.container} noValidate autoComplete="off">
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-name"
                          label="نام"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.name}
                          onChange={this.handleChange('name')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-price"
                          label="قیمت"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.price}
                          onChange={this.handleChange('price')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-price-with-offer"
                          label="قیمت با تخفیف"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.priceWithOffer}
                          onChange={this.handleChange('priceWithOffer')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-amount"
                          label="مقدار"
                          required
                          type="number"
                          fullWidth
                          className={classes.textField}
                          value={this.state.amount}
                          onChange={this.handleChange('amount')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-amount-type"
                          label="نوع مقدار"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.amountType}
                          onChange={this.handleChange('amountType')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-select-brand"
                          select
                          label="برند"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.brandId}
                          onChange={this.handleChange('brandId')}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                            },
                          }}
                          margin="normal"
                        >
                          {this.state.brands.map(option => (
                            <MenuItem key={option.brandId} value={option.brandId}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-select-product-type"
                          select
                          label="نوع محصول"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.productTypeId}
                          onChange={this.handleChange('productTypeId')}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                            },
                          }}
                          margin="normal"
                        >
                          {this.state.productTypes.map(option => (
                            <MenuItem key={option.productTypeId} value={option.productTypeId}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-available-count"
                          label="تعداد موجود"
                          type="number"
                          fullWidth
                          className={classes.textField}
                          value={this.state.availableCount}
                          onChange={this.handleChange('availableCount')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          id="standard-description"
                          label="توضیحات"
                          multiline
                          rows="4"
                          fullWidth
                          className={classes.textField}
                          value={this.state.description}
                          onChange={this.handleChange('description')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          id="standard-full-description"
                          label="توضیحات کامل"
                          multiline
                          rows="4"
                          fullWidth
                          className={classes.textField}
                          value={this.state.fullDescription}
                          onChange={this.handleChange('fullDescription')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          color="primary"
                          fullWidth
                          disabled={this.state.loading}
                          onClick={this.handleSave}>ذخیره</Button>
                      </Grid>
                    </Grid>
                  </form>
                </React.Fragment>
              </Grid>
              <Grid item md={5}>
                <div>
                  <input
                    accept="image/*"
                    className={classes.input}
                    style={{ display: 'none' }}
                    id="raised-button-file"
                    multiple
                    type="file"
                    onChange={this.handleSelectFile}
                  />
                  <label htmlFor="raised-button-file">
                    <Button
                      fullWidth
                      variant="contained"
                      component="span"
                      className={classes.button}
                    >
                      ارسال عکس جدید برای محصول
                      </Button>
                    {this.state.uploadPic && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </label>
                </div>
                <div>
                  <div className="picParent">
                    <img className="fullWidth" src={`http://adminpanel.zistagram-app.ir/${this.state.picUrl}`} alt={this.state.name} />
                  </div>
                </div>
              </Grid>
            </Grid>
          </Paper>
        </main>
      </React.Fragment>
    )
  };
}

Product.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Product));
